import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { Component } from 'react';
import ViewHelper from '../../helpers/ViewHelper';

class ItemIntro extends Component {
  componentDidMount() {
    this.showBackButton();
    window.addEventListener('scroll', this.showBackButton);
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.showBackButton);
  }

  showBackButton() {
    document.getElementById('hidden-back-button').classList.add('d-none');
  }

  titleCase(sentence) {
    let sentenceString = sentence.toString().split(' ');
    for (let i = 0; i < sentenceString.length; i++) {
      if (i !== 0) {
        sentenceString[i] = sentenceString[i].toLowerCase();
      }
    }
    return sentenceString.join(' ');
  }

  render() {
    let { menu, location } = this.props;
    const price = ViewHelper.toCurrency(
      menu.menu_price,
      location.currency,
      location.decimal_places
    );
    const discounted = ViewHelper.toCurrency(
      this.props.discountedPrice,
      location.currency,
      location.decimal_places
    );
    let grid_layout = localStorage.getItem('grid_layout');
    if (grid_layout === 'old') {
      return (
        <div className="item-intro p-3 row m-0 no-gutters card-color">
          <div id="item-name" className="col-8 f0 item-name card-font-color">
            <span id="hidden-back-button" className="d-none">
              <FontAwesomeIcon onClick={this.props.goBack} size={'sm'} icon={faArrowLeft} />
            </span>
            {menu.menu_name}
          </div>
          <div className="f1 col-4 item-price card-font-color d-flex align-items-end flex-column d-lg-none d-block d-sm-block d-md-block d-lg-block card-color">
            {menu.menu_price === menu.discounts.discountedPrice ? (
              price
            ) : (
              <>
                <span className="card-font-color discount-price">{discounted}</span>{' '}
                <span className="text-decoration-line-through actual-price card-font-color">{price}</span>
              </>
            )}
          </div>
        </div>
      );
    } else if (grid_layout !== 'old') {
      return (
        <div className="item-intro p-3 row m-0 gx-0 card-color">
          <div id="item-name" className="col-8 f0 item-name main-font-1">
            <span id="hidden-back-button" className="d-none">
              <FontAwesomeIcon onClick={this.props.goBack} size={'sm'} icon={faArrowLeft} />
            </span>
            {/* <span className={"item-modifier-quantity"}>{itemQuantity}x</span>  */}
            <h1 className={'item-modifier-menu-name card-font-color f0'}>{menu.menu_name}</h1>
          </div>
          <div className="f1 col-4 item-price main-font-1 text-end d-lg-none d-block d-sm-block d-md-block d-lg-block card-color card-font-color">
            {menu.menu_price === menu.discounts.discountedPrice ? (
              price
            ) : (
              <>
                <span className="card-font-color">{discounted}</span>{' '}
                <span className="text-decoration-line-through card-font-color">{price}</span>
              </>
            )}
          </div>
        </div>
      );
    }
  }
}

export default ItemIntro;
